module.exports = __webpack_public_path__ + "static/img/06.cc74c70c.png";